import * as React from "react";

const SvgIcnDragHandle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 10 16" fill="none" {...props}>
        <path d="M9.5 2a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" stroke="currentColor" />
        <circle cx={2} cy={2} r={1.5} stroke="currentColor" />
        <path d="M9.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" stroke="currentColor" />
        <circle cx={2} cy={8} r={1.5} stroke="currentColor" />
        <path d="M9.5 14a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" stroke="currentColor" />
        <circle cx={2} cy={14} r={1.5} stroke="currentColor" />
    </svg>
);

export default SvgIcnDragHandle;
